import { render } from "./SharingInstructions.vue?vue&type=template&id=d32822f2&ts=true"
import script from "./SharingInstructions.vue?vue&type=script&lang=ts"
export * from "./SharingInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__